import {SetCredentialsRequest} from './set-credentials-request.model';

export class SetCredentialsTokenRequest extends SetCredentialsRequest {
    token: string;

    constructor(obj: any = {}) {
        super(obj);
        this.token = obj && obj.token || null;
    }
}